import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="treatment-selector"
export default class extends Controller {
  static targets = ["bridgeForm", "pieceAttribute"]

  connect() {
    console.log("Treatment Selector connected")
  }

  handleTreatmentChange(event) {
    const treatment = event.target.value

    if (treatment === "puente") {
      this.bridgeFormTarget.classList.remove("hidden")
      this.pieceAttributeTargets.forEach(target => {
        target.classList.add("hidden")
      })
    } else {
      this.bridgeFormTarget.classList.add("hidden")
      this.pieceAttributeTargets.forEach(target => {
        target.classList.remove("hidden")
      })
    }
  }
}
